import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/**
 * Mục "Network" trong tab "Doanh thu & chia sẻ" (order 30 theo bản đồ phụ
 * thuộc). Cột trái: nó là dữ liệu nguồn của chuỗi chia, mà chuỗi chia nằm ở
 * cột phải.
 */
const channelTabs: TabKenh[] = [
  {
    id: 'network',
    nhom: 'doanh-thu-chia-se',
    cot: 'trai',
    label: 'Network và hợp đồng theo kỳ',
    order: 30,
    permission: { module: 'networks', level: 'view' },
    component: lazy(() => import('./components/TabNetwork.js')),
  },
];

export default channelTabs;
